import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { dsClass } from '../../../common/constants/dsClasses';
import { allPricesVatZeroMsg, monthlyChargesMsg, oneTimePaymentMsg, t, totalMsg } from '../../../common/i18n/index.js';
import { createPrices } from '../CustomFormFields.js';
import type { CustomFormProps } from '../CustomForm.js';

export const PriceSummary = ({ initialValues }: CustomFormProps) => {
  const {
    register,
    setValue,
    watch,
    formState: { isReady },
  } = useFormContext();

  const initialPrices = useMemo(
    () => createPrices(initialValues.periodicPriceMap ?? new Map(), initialValues.onetimePriceMap ?? new Map()),
    [initialValues.periodicPriceMap, initialValues.onetimePriceMap]
  );

  useEffect(() => {
    if (isReady) {
      setValue('periodicPriceMap', initialValues.periodicPriceMap);
      setValue('onetimePriceMap', initialValues.onetimePriceMap);
      setValue('periodicPrice', initialPrices.periodicPrice);
      setValue('onetimePrice', initialPrices.onetimePrice);
    }
  }, [isReady, initialValues.onetimePriceMap, initialValues.periodicPriceMap, initialPrices, setValue]);

  const periodicPriceValue = watch('periodicPrice') ?? initialPrices.periodicPrice;
  const onetimePriceValue = watch('onetimePrice') ?? initialPrices.onetimePrice;

  return (
    <div className="of-custom-form__prices">
      <input type="hidden" {...register('periodicPriceMap')} />
      <input type="hidden" {...register('onetimePriceMap')} />
      <input type="hidden" {...register('periodicPrice')} />
      <input type="hidden" {...register('onetimePrice')} />
      <h3 className={`of-custom-form__prices-title ${dsClass.H4}`}>{t.CEQ2(totalMsg)}</h3>
      <p className="of-custom-form__prices-content">
        <span>{t.P6BC(monthlyChargesMsg)}</span>
        <span>{periodicPriceValue}</span>
      </p>
      <p className="of-custom-form__prices-content">
        <span>{t.GOBY(oneTimePaymentMsg)}</span>
        <span>{onetimePriceValue}</span>
      </p>
      <p className={`of-custom-form__prices-disclaimer ${dsClass.TEXT_XS}`}>
        <span>{t.TEA3(allPricesVatZeroMsg)}</span>
      </p>
    </div>
  );
};
